module.exports = __webpack_public_path__ + "static/media/xray-training-lateral-nonflex2.a4679af9.png";